import { DiagnosticResults } from 'screens/patient';

export default DiagnosticResults;
